import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import AdvanceAlert from "./AdvanceAlert";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import CustomNavbar from "../CustomPermissions/CustomNavbar";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const AdvanceModelPage = () => {
  const [advances, setAdvances] = useState([]);
  const location = useLocation();
  const stateValue = location.state && location.state["userPermissions"];
  const [customPermissions, setCustomPerms] = useState([]);

  const [filters, setFilters] = useState({
    client_name: "",
    concern_person_name: "",
    mode_of_payment: "",
    city: "",
    state: "",
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [newAdvance, setNewAdvance] = useState(initialAdvanceState());
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [editAdvanceId, setEditAdvanceId] = useState(null);
  const [companies, setCompanies] = useState([]);

  function initialAdvanceState() {
    return {
      client_name: "",
      advance_date: "",
      concern_person_name: "",
      concern_person_number: "",
      amount: "",
      advance_attachment: null,
      percentage: "",
      mode_of_payment: "",
      bank_details: "",
      company: "",
      city: "",
      state: "",
      pdc_date: "",
      cheque_date: ""
    };
  }

  useEffect(() => {
    fetchAdvances();
    fetchCompanies();
  }, []);

  const fetchAdvances = async () => {
    try {
      const response = await axios.get(
        getApiUrl("/Advance/advances/")
      );
      const storedPermissions =
        JSON.parse(localStorage.getItem("custom_permissions")) || [];
      setCustomPerms(storedPermissions);
      setAdvances(response.data);
    } catch (error) {
      // console.error("Failed to fetch advances:", error);
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await axios.get(
        getApiUrl("/PartnerFiles/companies/"),
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      setCompanies(response.data.data);
    } catch (error) {
      // console.error("Error fetching companies:", error);
    }
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewAdvance({ ...newAdvance, [name]: value });
  };

  const handleFileChange = (e) => {
    setNewAdvance({ ...newAdvance, advance_attachment: e.target.files[0] });
  };

  const handleSubmit = async () => {
    const url = editAdvanceId
      ? getApiUrl(`/Advance/advances/${editAdvanceId}/update/`)
      : getApiUrl("/Advance/advances/create/");
    const method = editAdvanceId ? "put" : "post";

    const formData = new FormData();
    Object.keys(newAdvance).forEach((key) => {
      formData.append(key, newAdvance[key]);
    });

    try {
      await axios({
        method,
        url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });

      setNewAdvance(initialAdvanceState());
      setModalOpen(false);
      setEditAdvanceId(null);
      fetchAdvances();
    } catch (error) {
      // console.error("Failed to submit advance:", error);
    }
  };

  const handleEdit = (advance) => {
    setNewAdvance({
      client_name: advance.client_name,
      advance_date: advance.advance_date,
      concern_person_name: advance.concern_person_name,
      concern_person_number: advance.concern_person_number,
      amount: advance.amount,
      advance_attachment: advance.advance_attachment,
      percentage: advance.percentage,
      mode_of_payment: advance.mode_of_payment,
      bank_details: advance.bank_details,
      company: advance.company,
      city: advance.city,
      state: advance.state,
      pdc_date: advance.pdc_date,
      cheque_date: advance.cheque_date
    });
    setEditAdvanceId(advance.id);
    setModalOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      try {
        await axios.delete(
          getApiUrl(`/Advance/advances/${id}/delete/`)
        );
        fetchAdvances();
      } catch (error) {
        // console.error("Failed to delete advance:", error);
      }
    }
  };

  const toggleRowExpansion = (id) => {
    setExpandedRowId(expandedRowId === id ? null : id);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [modeOfPayment, setModeOfPayment] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  // Filter logic - matches across all fields including date range
  const filteredAdvances = advances.filter((advance) => {
    const matchesSearch = !searchTerm ||
      Object.values(advance)
        .join(" ") // Combines all values into a single string
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
    
    const matchesMode = !modeOfPayment || advance.mode_of_payment === modeOfPayment;
    
    // Date range filter
    const advanceDate = new Date(advance.advance_date);
    const fromDate = dateFrom ? new Date(dateFrom) : null;
    const toDate = dateTo ? new Date(dateTo) : null;
    
    let matchesDate = true;
    if (fromDate) {
      matchesDate = matchesDate && advanceDate >= fromDate;
    }
    if (toDate) {
      // Set toDate to end of day for inclusive filtering
      const toDateEndOfDay = new Date(toDate);
      toDateEndOfDay.setHours(23, 59, 59, 999);
      matchesDate = matchesDate && advanceDate <= toDateEndOfDay;
    }
    
    return matchesSearch && matchesMode && matchesDate;
  }).sort((a, b) => {
    // Sort by date (latest first)
    const dateA = new Date(a.advance_date);
    const dateB = new Date(b.advance_date);
    return dateB - dateA; // Latest first
  });

  return (
    <div
      style={{
        display: "flex",
        // backgroundColor: "#f0f4f8",
        // minHeight: "100vh",
      }}
    >
      <CustomNavbar />

      <div style={{ flex: 1, padding: "0", minHeight: "100vh" }}>
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            padding: "24px",
            // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "24px",
            }}
          >
            <h2
              className="text-blue-700"
              style={{ fontSize: "2rem", fontWeight: "600" }}
            >
              Advance Records
            </h2>
            <Button
              variant="contained"
              className="text-blue-700"
              onClick={() => {
                setNewAdvance(initialAdvanceState());
                setEditAdvanceId(null);
                setModalOpen(true);
              }}
            >
              Add New Advance
            </Button>
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 2fr)",
              gap: "16px",
              marginBottom: "24px",
            }}
          >
            {/* Single Search Input */}
            <TextField
              label="Search"
              variant="outlined"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              fullWidth
              size="small"
              sx={{ backgroundColor: "#fff", borderRadius: 2 }}
              placeholder="Search by name, city, state, etc."
            />
            {/* Date From Filter */}
            <TextField
              label="Date From"
              type="date"
              variant="outlined"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
              sx={{ backgroundColor: "#fff", borderRadius: 2 }}
            />
            {/* Date To Filter */}
            <TextField
              label="Date To"
              type="date"
              variant="outlined"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              fullWidth
              size="small"
              InputLabelProps={{ shrink: true }}
              sx={{ backgroundColor: "#fff", borderRadius: 2 }}
            />

            {/* Mode of Payment Dropdown */}
            <FormControl
              fullWidth
              size="small"
              sx={{ backgroundColor: "#fff", borderRadius: 2 }}
            >
              <InputLabel>Mode of Payment</InputLabel>
              <Select
                value={modeOfPayment}
                onChange={(e) => setModeOfPayment(e.target.value)}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="Bank">Bank</MenuItem>
                <MenuItem value="Cash">Cash</MenuItem>
                <MenuItem value="PDC">PDC</MenuItem>
              </Select>
            </FormControl>
          </div>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <thead style={{ color: "#ffffff" }}>
              <tr className="bg-blue-500">
                <th style={{ padding: "12px", textAlign: "left" }}>#</th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Client Name
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Advance Date
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>
                  Concern Person
                </th>
                <th style={{ padding: "12px", textAlign: "left" }}>Amount</th>
                <th style={{ padding: "12px", textAlign: "left" }}>View</th>
              </tr>
            </thead>
            <tbody>
              {filteredAdvances.map((advance, index) => (
                <React.Fragment key={advance.id}>
                  <tr
                    style={{
                      backgroundColor: index % 2 === 0 ? "#f8fafc" : "#ffffff",
                      cursor: "pointer",
                    }}
                    onClick={() => toggleRowExpansion(advance.id)}
                  >
                    <td
                      style={{
                        padding: "12px",
                        borderBottom: "1px solid #e2e8f0",
                      }}
                    >
                      {index + 1}
                      <AdvanceAlert advance={advance} />{" "}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        borderBottom: "1px solid #e2e8f0",
                      }}
                    >
                      {advance.client_name}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        borderBottom: "1px solid #e2e8f0",
                      }}
                    >
                      {advance.advance_date}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        borderBottom: "1px solid #e2e8f0",
                      }}
                    >
                      {advance.concern_person_name}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        borderBottom: "1px solid #e2e8f0",
                      }}
                    >
                      {advance.amount}
                    </td>

                    <td
                      style={{
                        padding: "12px",
                        borderBottom: "1px solid #e2e8f0",
                        textAlign: "center",
                      }}
                    >
                      {advance.advance_attachment ? (
                        <>
                          <a
                            href={getApiUrl(`/media/${advance.advance_attachment}`)}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#1e3a8a", textDecoration: "none" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              viewBox="0 0 16 16"
                            >
                              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                            </svg>
                          </a>
                        </>
                      ) : (
                        <>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-eye-slash-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                            <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                          </svg>
                        </>
                      )}
                    </td>
                  </tr>
                  {expandedRowId === advance.id && (
                    <tr style={{ backgroundColor: "#f0f4f8" }}>
                      <td
                        colSpan="6"
                        style={{
                          padding: "16px",
                          borderBottom: "1px solid #e2e8f0",
                        }}
                      >
                        <p>
                          <strong>Concern Person Number:</strong>{" "}
                          {advance.concern_person_number}
                        </p>
                        <p>
                          <strong>Percentage:</strong> {advance.percentage}
                        </p>
                        <p>
                          <strong>City:</strong> {advance.city}
                        </p>
                        <p>
                          <strong>State:</strong> {advance.state}
                        </p>
                        <p>
                          <strong>Company:</strong> {advance.company__name}
                        </p>
                        <p>
                          <strong>Mode of Payment:</strong>{" "}
                          {advance.mode_of_payment}
                        </p>
                        <p>
                          <strong>PDC Date:</strong> {advance.pdc_date}
                        </p>

                        <p>
                          <strong>Cheque Date:</strong> {advance.cheque_date}
                        </p>
                        <p>
                          <strong>Bank Details:</strong> {advance.bank_details}
                        </p>
                        {/* Call PDCAlert component */}
                        <div style={{ display: "flex", marginTop: "16px" }}>
                          <Button
                            variant="outlined"
                            sx={{
                              color: "#1e3a8a",
                              borderColor: "#1e3a8a",
                              marginRight: "8px",
                              "&:hover": { borderColor: "#1d4ed8" },
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(advance);
                            }}
                          >
                            Edit
                          </Button>

                          {customPermissions &&
                          customPermissions.includes("auth.custom_advance") ? (
                            <>
                              <Button
                                variant="outlined"
                                sx={{
                                  color: "#dc2626",
                                  borderColor: "#dc2626",
                                  "&:hover": { borderColor: "#ef4444" },
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete(advance.id);
                                }}
                              >
                                Delete
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button
                                variant="outlined"
                                sx={{
                                  color: "#dc2626",
                                  borderColor: "#dc2626",
                                  "&:hover": { borderColor: "#ef4444" },
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete(advance.id);
                                }}
                              >
                                Delete
                              </Button>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle
          sx={{ backgroundColor: "#1e3a8a", color: "#ffffff", padding: "16px" }}
        >
          {editAdvanceId ? "Edit Advance" : "New Advance"}
        </DialogTitle>
        <DialogContent sx={{ padding: "24px", backgroundColor: "#f8fafc" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "16px",
              paddingTop: "25px",
            }}
          >
            <TextField
              label="Client Name"
              name="client_name"
              value={newAdvance.client_name}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              required
              sx={{ backgroundColor: "#ffffff" }}
            />
            <TextField
              label="Advance Date"
              type="date"
              name="advance_date"
              value={newAdvance.advance_date}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              // required
              sx={{ backgroundColor: "#ffffff" }}
            />
            <TextField
              label="Concern Person Name"
              name="concern_person_name"
              value={newAdvance.concern_person_name}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              // required
              sx={{ backgroundColor: "#ffffff" }}
            />
            <TextField
              label="Concern Person Number"
              name="concern_person_number"
              value={newAdvance.concern_person_number}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              required
              sx={{ backgroundColor: "#ffffff" }}
            />
            <TextField
              label="Amount"
              type="number"
              name="amount"
              value={newAdvance.amount}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              required
              sx={{ backgroundColor: "#ffffff" }}
            />
            <TextField
              label="Percentage"
              name="percentage"
              value={newAdvance.percentage}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              required
              sx={{ backgroundColor: "#ffffff" }}
            />
            <TextField
              label="City"
              name="city"
              value={newAdvance.city}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              // required
              sx={{ backgroundColor: "#ffffff" }}
            />
            <TextField
              label="State"
              name="state"
              value={newAdvance.state}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              // required
              sx={{ backgroundColor: "#ffffff" }}
            />
            <FormControl fullWidth sx={{ backgroundColor: "#ffffff" }}>
              <InputLabel>Mode of Payment</InputLabel>
              <Select
                name="mode_of_payment"
                value={newAdvance.mode_of_payment}
                onChange={handleInputChange}
                variant="outlined"
                fullWidth
                required
              >
                <MenuItem value="">Select Mode</MenuItem>
                <MenuItem value="Bank">Bank</MenuItem>
                <MenuItem value="Cash">Cash</MenuItem>
                <MenuItem value="Cheque">Cheque</MenuItem>
                <MenuItem value="PDC">PDC</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ backgroundColor: "#ffffff" }}>
              <InputLabel>Company</InputLabel>
              <Select
                name="company"
                value={newAdvance.company}
                onChange={handleInputChange}
                variant="outlined"
                onOpen={fetchCompanies}
                fullWidth
                // required
              >
                <MenuItem value="">--Select Company--</MenuItem>
                {companies.map((company) => (
                  <MenuItem key={company.id} value={company.id}>
                    {company.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="PDC Date"
              type="date"
              name="pdc_date"
              value={newAdvance.pdc_date}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              sx={{ backgroundColor: "#ffffff" }}
            />
            <TextField
              label="Cheque Date"
              type="date"
              name="cheque_date"
              value={newAdvance.cheque_date}
              onChange={handleInputChange}
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              sx={{ backgroundColor: "#ffffff" }}
            />
            <TextField
              label="Bank Details"
              name="bank_details"
              value={newAdvance.bank_details}
              onChange={handleInputChange}
              variant="outlined"
              // fullWidth
              sx={{ backgroundColor: "#ffffff" }}
            />
            <TextField
              type="file"
              onChange={handleFileChange}
              variant="outlined"
              fullWidth
              sx={{ backgroundColor: "#ffffff" }}
            />
          </div>
        </DialogContent>
        <DialogActions sx={{ padding: "16px", backgroundColor: "#f8fafc" }}>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{
              backgroundColor: "#1e3a8a",
              "&:hover": { backgroundColor: "#1d4ed8" },
            }}
          >
            {editAdvanceId ? "Update" : "Submit"}
          </Button>
          <Button
            onClick={() => setModalOpen(false)}
            variant="outlined"
            sx={{
              color: "#1e3a8a",
              borderColor: "#1e3a8a",
              "&:hover": { borderColor: "#1d4ed8" },
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AdvanceModelPage;
